<template>
  <div class="tw-p-[24px] lg:tw-p-[40px] tw-flex tw-flex-col tw-bg-[#FFF]">
    <!-- Content -->
    <div class="tw-flex tw-gap-[26px] tw-flex-col md:tw-flex-row tw-flex-wrap">
      <div
        data-cy="vendor-assess-modal-create-new-assess-create-new-template-btn"
        :class="`tw-cursor-pointer tw-pt-[22px] tw-pb-[16px] tw-px-[16px] lg:tw-px-[30px] tw-flex-1 tw-h-[347px] tw-flex tw-flex-col tw-items-center tw-bg-[#F2F8FF] tw-rounded-[4px] ${
          !isShowWarning ? 'tw-justify-center' : ''
        }`"
        @click="handleCreateNewTemplate"
      >
        <div class="tw-mb-[14px]">
          <AddNewTemplateIcon />
        </div>
        <div
          :class="`tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 ${
            isShowWarning ? 'tw-mb-[20px]' : ''
          }`"
        >
          <div class="tw-text-[#211F58] tw-text-[15px] tw-font-medium">
            {{
              getComponentUiText(
                "app-modal-create-a-new-vendor-assessment-title-create-a-new-template-to-use-1",
              )
            }}
          </div>
          <div
            class="tw-text-[#878787] tw-text-[13px] tw-font-normal tw-text-center"
          >
            {{
              getComponentUiText(
                "app-modal-create-a-new-vendor-assessment-description-create-a-new-template-to-use-1",
              )
            }}
          </div>
        </div>
        <div v-if="isShowWarning" class="create-new-ass-modal-note">
          <InfoIcon />
          {{ getComponentUiText("app-vendor-assessment-create-new-note-1") }}
        </div>
      </div>
      <div
        class="tw-cursor-pointer tw-p-[16px] lg:tw-px-[30px] tw-flex-1 tw-h-[347px] tw-flex tw-flex-col tw-items-center tw-gap-5 tw-bg-[#F2F8FF] tw-rounded-[4px]"
      >
        <div>
          <AddNewTemplateIcon2 />
        </div>
        <div
          class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2"
        >
          <div class="tw-text-[#211F58] tw-text-[15px] tw-font-medium">
            {{
              getComponentUiText(
                "app-modal-create-a-new-vendor-assessment-title-use-an-existing-template-1",
              )
            }}
          </div>
          <div
            class="tw-text-[#878787] tw-text-[13px] tw-font-normal tw-text-center"
          >
            {{
              getComponentUiText(
                "app-modal-create-a-new-vendor-assessment-description-use-an-existing-template-1",
              )
            }}
          </div>
        </div>
        <div class="tw-w-[100%] tw-flex tw-justify-center">
          <BaseDropDown
            :id="'preferredLanguage'"
            v-model="form.data"
            :data="existingTemplateData"
            data-cy-id="existing-template-dropdown"
            :class-name="'gray-dropdown-container tw-h-[58px]'"
            :placeholder="
              getComponentUiText(
                'app-vendor-dropdown-placehoder-choose-template-1',
              )
            "
            :validation="v$.data"
            :show-validate="true"
            :is-option-button-dropdown="true"
            :text-option-button-dropdown="
              getComponentUiText(
                'app-vendor-create-a--new-assessment-option-dropdown-1',
              )
            "
            :bg-dropdown="'#FFF'"
            :custom-select-container="'tw-text-[15px] tw-font-medium tw-leading-[15px]'"
          />
        </div>
      </div>
    </div>

    <!-- Button -->
    <div
      :class="`tw-flex tw-mt-10 sm:tw-flex-row tw-justify-between tw-gap-[15px] sm:tw-gap-[0px]`"
    >
      <button
        class="tw-border-[#F7553C] hover:tw-bg-[#F7553C] hover:tw-text-white tw-border-solid tw-border-[2px] tw-w-fit tw-shadow-none tw-bg-[#fff] tw-text-[#F7553C] tw-py-[8px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[27px] tw-leading-normal"
        @click="handleCloseModal(true)"
      >
        {{
          getComponentUiText(
            "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
          )
        }}
      </button>
      <button
        data-cy="go-btn"
        class="tw-ml-[15px] tw-text-[#fff] tw-bg-[#387DFF] hover:tw-bg-[#0069d9] tw-py-[8px] tw-px-[20px] tw-text-[13px] tw-rounded-[27px] tw-leading-normal tw-font-medium tw-border-[#387DFF] tw-border-solid tw-border-[2px]"
        @click="openModalCreateNewVendorAssessment(form.data)"
      >
        {{
          getComponentUiText(
            "app-modal-create-a-new-vendor-assessment-btn-go-1",
          )
        }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getComponentUiText } from "@/utils/utilities";
import { computed, ref, watch } from "vue";
import AddNewTemplateIcon from "../svgs/addNewTemplateIcon.vue";
import AddNewTemplateIcon2 from "../svgs/addNewTemplateIcon2.vue";
import BaseDropDown from "../common/form/baseDropDown.vue";
import router from "@/router";
import store from "@/store";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import InfoIcon from "../svgs/infoIcon.vue";

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  maxWidth: {
    type: Number,
    required: false,
    default: 65,
  },
  isShowWarning: {
    type: Boolean,
    required: false,
    default: false,
  },
});

let showRef = ref(props.show);
const data = ref("");
const form = ref({
  data: "",
});

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

watch(
  () => form.value.data,
  (value) => {
    if (value) {
      emit("update:selection", value);
    }
  },
);

const existingTemplateData = computed(() =>
  store.state.Vendor.checklistRequestedTemplate
    .filter((item) => item.itemCount > 0)
    .map((item) => ({
      ...item,
      id: item.templateId,
      name: item.templateName,
    })),
);

const openModalCreateNewVendorAssessment = async (item) => {
  await v$.value.$validate();
  if (v$.value.$invalid) return;
  emit("update:templateId", item);
};

const emit = defineEmits([
  "update:show",
  "update:close",
  "update:templateId",
  "update:selection",
]);

const handleCloseModal = (isCancel = false) => {
  showRef.value = false;
  emit("update:show", showRef.value);
  emit("update:close", isCancel);
};

const handleCreateNewTemplate = () => {
  store.commit("Vendor/SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID", []);
  router.push({ path: "/assess/vendor/template" });
  handleCloseModal();
};

const rules = {
  data: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};
const v$ = useVuelidate(rules, form as any);
</script>

<style lang="scss" scoped>
.create-new-ass-modal-note {
  background: #fff0da;
  color: #fe9a05;
  margin-left: -15px;
  margin-right: -15px;
  padding: 4px 8px;
  font-size: 12px;
  text-align: center;
  border-radius: 6px;
  display: flex;
  gap: 8px;
}
@media screen and (max-width: 991px) {
  .v-modal .v-modal-contain .v-modal-container {
    overflow: scroll !important;
  }
  .create-new-ass-modal-note {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
